// extracted by mini-css-extract-plugin
module.exports = {"learn-more-text-button":"_4_T-c","learnMoreTextButton":"_4_T-c"};